import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Flag from 'react-world-flags';
import classNames from 'classnames';

import './flagSelect.css'

export const MySelect = React.forwardRef(({
    onSelectChange,
    placeholder,
    values,
    name,
    closeMenu = true,
    setValue,
    isRequired,
}, ref) => {


    // let transformedValues = values ? values.map(item => ({
    //     id: item.id, 
    //     value: item.country.alpha2Code,  
    //     areaCode: item.prefix           
    // })) : []


    //console.log('tramsformedValues: ', transformedValues)

    const [selectedOption, setSelectedOption] = useState(null)
    const [onBlurError, setOnBlurError] = useState('')
    const [errorMessage, setErrorMessage] = useState(false)

    useEffect(() => {
        if (onSelectChange) {
            onSelectChange(selectedOption)
        }
    }, [selectedOption, onSelectChange])

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption)

        if (Array.isArray(selectedOption)) {
            const selectedIds = selectedOption.map(i => i.id)
            setValue(name, selectedIds)
        } else {
            setValue(name, selectedOption?.id || null) //👉 Establecemos el ID de la opción seleccionada
        }

        // Reseteamos el error
        setOnBlurError('');
        setErrorMessage(false);
    };

    const handleBlur = () => {

        if (!selectedOption && isRequired) {
            setOnBlurError('inErrorSelect')
            setErrorMessage(true)
        }
    };

    //? reemplazarlo por el helper 
    const getValues = () => {


        if (!values) {
            return values
        }

        let transformedValues = values.map(item => ({
            id: item.id,
            value: item.country.alpha2Code,
            areaCode: item.prefix
        })) 


        //console.log('tramsformedValues: ', transformedValues)

        //console.log('values: ', placeholder)
        let newValues = [
            ...transformedValues
        ]

        if (placeholder) {

            newValues = [
                {
                    id: '',
                    value: placeholder,
                    areaCode: ''
                },
                ...transformedValues
            ]
        }
        //console.log('newValues: ', newValues)
        return newValues

    }


    const CustomSingleValue = (props) => {

        //console.log('props: ', props)
        const { data } = props

        return (
            <div className='flagStyle' style={{ display: 'flex', alignItems: 'center' }}>
                <Flag code={data.value} width={20} style={{ marginRight: 10 }} />
                <span>{data.areaCode.length > 0 ? `(+${data.areaCode})` : placeholder}</span>
            </div>
        );
    };

    return (
        <div className="App">
            <Select
                // options={transformedValues} 
                options={getValues()}
                components={{ SingleValue: CustomSingleValue }}
                getOptionLabel={(e) => (



                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Flag code={e.value} width={20} style={{ marginRight: 10 }} />
                        <span> {e.areaCode.length > 0 ? `(+${e.areaCode})` : placeholder}  </span>
                    </div>
                )}
                // onBlur={handleBlur}
                className={classNames(onBlurError)}
                onChange={handleChange}
                ref={ref}
                placeholder={placeholder}
                closeMenuOnSelect={closeMenu}
            />

            {errorMessage && (
                <span className='invalid-feedback d-flex field-validation-error'>
                    <span className="error-message">Campo requerido</span>
                </span>
            )}
        </div>
    )
})

//👉 Componente personalizado para mostrar la bandera y el código de área en la selección

